import {
  RENT_HISTORY_BEGIN,
  RENT_HISTORY_SUCCESS,
  RENT_HISTORY_MODIFY_DEVICE_SUCCESS,
  RENT_HISTORY_DETACH_DEVICE_SUCCESS,
  RENT_HISTORY_ERROR,
} from './constants';

export const rentHistoryBegin = () => ({
  type: RENT_HISTORY_BEGIN,
});

export const rentHistorySuccess = payload => ({
  type: RENT_HISTORY_SUCCESS,
  payload,
});

export const rentHistoryModifyDeviceSuccess = payload => ({
  type: RENT_HISTORY_MODIFY_DEVICE_SUCCESS,
  payload,
});

export const rentHistoryDetachDeviceSuccess = payload => ({
  type: RENT_HISTORY_DETACH_DEVICE_SUCCESS,
  payload,
});

export const rentHistoryError = payload => ({
  type: RENT_HISTORY_ERROR,
  payload,
});
